// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"d3a25853","141":"0686934d","377":"4c4fe962","787":"64828776","893":"bfaf84aa"}[chunkId] + ".chunk.js";
};